var _path, _path2, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVideoMuted(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 58,
    viewBox: "0 0 58 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29 57C44.464 57 57 44.464 57 29C57 13.536 44.464 1 29 1C13.536 1 1 13.536 1 29C1 44.464 13.536 57 29 57Z",
    fill: "white",
    stroke: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.3814 23.0911C21.3371 23.0911 20.4905 23.9377 20.4905 24.982V32.5457C20.4905 33.59 21.3371 34.4366 22.3814 34.4366H29.9451C30.9894 34.4366 31.836 33.59 31.836 32.5457V24.982C31.836 23.9377 30.9894 23.0911 29.9451 23.0911H22.3814ZM33.7248 24.8561L36.2982 22.7116C37.1004 22.043 38.2928 22.1514 38.9613 22.9537C39.2445 23.2935 39.3996 23.7219 39.3996 24.1642V33.3634C39.3996 34.4077 38.553 35.2543 37.5087 35.2543C37.0663 35.2543 36.638 35.0993 36.2982 34.8161L33.7248 32.6716C33.6584 34.7019 31.9916 36.3275 29.9451 36.3275H22.3814C20.2928 36.3275 18.5996 34.6343 18.5996 32.5457V24.982C18.5996 22.8934 20.2928 21.2002 22.3814 21.2002H29.9451C31.9916 21.2002 33.6584 22.8257 33.7248 24.8561ZM33.7269 27.3158V30.2119L37.5087 33.3634V24.1642L33.7269 27.3158Z",
    fill: "#07141F"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 39.2416,
    y: 18.427,
    width: 3,
    height: 29,
    rx: 1.5,
    transform: "rotate(51.615 39.2416 18.427)",
    fill: "#07141F",
    stroke: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoMuted);
export default __webpack_public_path__ + "static/media/videoMuted.7919caa9cb8f336f055ffa91b8cfea34.svg";
export { ForwardRef as ReactComponent };